import { render } from "./FooterSectionThree.vue?vue&type=template&id=50274023"
import script from "./FooterSectionThree.vue?vue&type=script&lang=js"
export * from "./FooterSectionThree.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__